import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { useMemo } from "react";
import { usePage } from "@inertiajs/react";
import {
  AppNotificationsAPIService,
  type DismissAppNotificationResponse,
} from "@rails_api_base";
import type { SharedPageProps } from "~/layouts/site-layout";

export function useAppNotificationsService() {
  const { jwt, root_path } = usePage<SharedPageProps>().props;
  return useMemo(
    () => new AppNotificationsAPIService({ jwt, baseUrl: root_path }),
    [jwt, root_path]
  );
}

export function useDismissAppNotification(
  options?: Omit<
    UseMutationOptions<DismissAppNotificationResponse, Error, number>,
    "mutationFn"
  >
) {
  const service = useAppNotificationsService();
  return useMutation({
    mutationFn: (id: number) => service.dismiss(id),
    ...options,
  });
}
